/**
 *
 * @module logSink
 *
 */

/* eslint no-unused-vars: "off" */

import LogLevel from './logLevel';

/**
 *
 * @abstract LogSink
 * @desc Defines the contract for a logging "endpoint" that can be registered with the Logger.
 *
 * @note a LogSink implementation will construct with a LogLevel, filtering out events that fall below that
 * level. Further each LogSink will log these LogEvents in a unique way, examples being:
 *
 * ConsoleSink: writes the logEvent as a string to the console
 * MemorySink: simply stores the logEvent in an array.
 * Potential NetworkSinks will POST the logEvent to a URL.
 *
 */
export default class LogSink {

    /**
     *
     * @param {LogLevel} [logLevel=LogLevel.none]
     *
     */
    constructor(logLevel = LogLevel.none) {

        /**
         *
         * @access public
         * @type {LogLevel}
         *
         */
        this.logLevel = logLevel;

    }

    /**
     *
     * @access public
     * @param {LogEvent} logEvent - The event to be logged.
     *
     */
    log(logEvent) {

        throw new ReferenceError('Sink must implement log(LogEvent)');

    }

}



// WEBPACK FOOTER //
// ./src/logging/logSink.js